import type { Itinerary } from '../types/itineraryMaintenance';

export const mockItineraries: Itinerary[] = [
  {
    id: '1',
    itineraryCode: 'ABRP',
    itineraryName: 'Abra',
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '2',
    itineraryCode: 'ABW',
    itineraryName: 'Aruba',
    isActive: true,
    createdAt: new Date('2024-02-10'),
    lastModified: new Date('2025-01-15')
  },
  {
    id: '3',
    itineraryCode: 'AGNP',
    itineraryName: 'Agusan del Norte',
    isActive: true,
    createdAt: new Date('2024-03-05'),
    lastModified: new Date('2025-01-14')
  },
  {
    id: '4',
    itineraryCode: 'AGO',
    itineraryName: 'Angola',
    isActive: true,
    createdAt: new Date('2024-04-20'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '5',
    itineraryCode: 'AGSP',
    itineraryName: 'Agusan del Sur',
    isActive: true,
    createdAt: new Date('2024-05-12'),
    lastModified: new Date('2024-12-20')
  },
  {
    id: '6',
    itineraryCode: 'SVN',
    itineraryName: 'Slovenia',
    isActive: true,
    createdAt: new Date('2024-06-08'),
    lastModified: new Date('2025-01-10')
  },
  {
    id: '7',
    itineraryCode: 'SWE',
    itineraryName: 'Sweden',
    isActive: true,
    createdAt: new Date('2024-07-15'),
    lastModified: new Date('2025-01-12')
  },
  {
    id: '8',
    itineraryCode: 'SYC',
    itineraryName: 'Seychelles',
    isActive: true,
    createdAt: new Date('2024-08-22'),
    lastModified: new Date('2025-01-08')
  },
  {
    id: '9',
    itineraryCode: 'SYR',
    itineraryName: 'Syria (Syrian Arab Republic)',
    isActive: false,
    createdAt: new Date('2024-09-18'),
    lastModified: new Date('2024-12-15')
  },
  {
    id: '10',
    itineraryCode: 'TACP',
    itineraryName: 'Tacloban (Leyte)',
    isActive: true,
    createdAt: new Date('2024-10-25'),
    lastModified: new Date('2025-01-05')
  },
  {
    id: '11',
    itineraryCode: 'USA',
    itineraryName: 'United States of America',
    isActive: true,
    createdAt: new Date('2024-11-12'),
    lastModified: new Date('2025-01-18')
  },
  {
    id: '12',
    itineraryCode: 'JPN',
    itineraryName: 'Japan',
    isActive: true,
    createdAt: new Date('2024-12-01'),
    lastModified: new Date('2025-01-20')
  }
];